import {connect} from "react-redux";
import RejectActivity from "./Reject";
import {bindActionCreators} from "redux";
import {dropdownData} from "../../../service/Account/action";
import {nextActivity, activityProposal, checkCloseOrDropped, newActivity, cancelActivity,
    rejectActivity} from "../../../service/Activity/action";
import {documentUploadUrlPublic} from "../../../service/fileUpload/action";

const mapStateToProps = (state) => ({
    nextActivityDetails:state.Activity.nextActivity,
    proposalActivity:state.Activity.proposalActivity,
    checkOpportunity:state.Activity.checkOpportunity,
    saveNewActivity:state.Activity.saveNewActivity,
    rejectActivityDetails:state.Activity.rejectActivity,
    cancelActivityDetails:state.Activity.cancelActivity,
    dropdownValue:state.Dropdown.dropdownValue,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            dropdownData,
            nextActivity,
            documentUploadUrlPublic,
            activityProposal,
            checkCloseOrDropped,
            newActivity,
            cancelActivity,
            rejectActivity
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(RejectActivity);
